export function ContactToUs() {
  // window.location.href = "https://t.me/Onchain_CS1" // usdc
  window.location.href = "https://t.me/Onchain818" // eth
}